import { render } from "./operationManual2.vue?vue&type=template&id=253e3f19&scoped=true"
import script from "./operationManual2.vue?vue&type=script&lang=js"
export * from "./operationManual2.vue?vue&type=script&lang=js"

import "./operationManual2.vue?vue&type=style&index=0&id=253e3f19&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-253e3f19"

export default script